import React, {Component} from 'react';
import update from 'immutability-helper';
import Select from 'react-select'

import I18n from 'app/common/i18n';


export default class SkillFilter extends Component {

	constructor(props) {
		super(props)
		this.state = {
			options: [
			  { value: 'java-beginner', label: 'Java Beginner' },
			  { value: 'java-intermediate', label: 'Java Intermediate' },
			  { value: 'java-expert', label: 'Java Expert' },
			  { value: 'c-intermediate', label: 'C Beginner' },
			  { value: 'c-intermediate', label: 'C Intermediate' },
			  { value: 'c-intermediate', label: 'C Expert' },
			  { value: 'python-intermediate', label: 'Python Intermediate' }
			],
			value: '',
			disabled: false
		}
	}



	handleSelectChange (value) {
		let {filter, updateFilter} = this.props;
		let _filter = update(filter, {skills: {$set: value}})
		updateFilter(_filter);
	}

	render() {
		let {filter: {skills}, assessments} = this.props;
		return (
			<div className='col-5 p2'>
				<Select
					multi
					simpleValue
					disabled={this.state.disabled}
					value={skills}
					simpleValue={false}
					labelKey='name'
          valueKey='id'
          autoBlur={true}
					placeholder={I18n.t('candidates.filter_placeholder')}
					options={assessments} onChange={(value) => this.handleSelectChange(value)} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/candidates/SkillFilter.js